import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@heroui/button";
import { Moon, Sun } from "lucide-react";

import { useTheme } from "../../context/ThemeContext";

const NotFoundPage: React.FC = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <div
      className={`min-h-screen flex flex-col items-center justify-center bg-gray-100 dark:bg-gray-900 ${theme === "dark" ? "dark" : ""}`}
    >
      <div className="absolute top-4 right-4">
        <Button
          isIconOnly
          aria-label={`Switch to ${theme === "light" ? "dark" : "light"} mode`}
          className="bg-white dark:bg-gray-800 shadow-sm"
          variant="light"
          onPress={toggleTheme}
        >
          {theme === "light" ? (
            <Moon className="w-5 h-5" />
          ) : (
            <Sun className="w-5 h-5" />
          )}
        </Button>
      </div>

      <div className="text-center max-w-md px-4">
        <div className="text-9xl font-bold text-primary-500 mb-4">404</div>
        <div className="relative w-64 h-64 mx-auto mb-8">
          <svg
            className="w-full h-full"
            viewBox="0 0 200 200"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              className="fill-gray-300 dark:fill-gray-700"
              cx="100"
              cy="100"
              r="80"
            />
            <circle
              className="fill-gray-100 dark:fill-gray-800 stroke-gray-400 dark:stroke-gray-600"
              cx="100"
              cy="100"
              r="70"
              strokeWidth="2"
            />
            <path
              className="fill-yellow-300 dark:fill-yellow-600 stroke-yellow-500 dark:stroke-yellow-400"
              d="M100,40 L130,110 A40,40 0 0,1 70,110 Z"
              strokeWidth="2"
            />
            <circle
              className="fill-yellow-500 dark:fill-yellow-400"
              cx="100"
              cy="70"
              r="5"
            />
            <circle
              className="fill-yellow-500 dark:fill-yellow-400"
              cx="120"
              cy="85"
              r="5"
            />
            <circle
              className="fill-yellow-500 dark:fill-yellow-400"
              cx="85"
              cy="90"
              r="5"
            />
            <circle
              className="fill-gray-600 dark:fill-gray-400"
              cx="92"
              cy="75"
              r="3"
            />
            <circle
              className="fill-gray-600 dark:fill-gray-400"
              cx="108"
              cy="75"
              r="3"
            />
            <path
              className="stroke-gray-600 dark:stroke-gray-400"
              d="M85,95 Q100,85 115,95"
              fill="none"
              strokeLinecap="round"
              strokeWidth="3"
            />
          </svg>
        </div>

        <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-4">
          Page Not Found
        </h1>
        <p className="text-gray-600 dark:text-gray-400 mb-8">
          We couldn't find the page you're looking for. The link might be
          incorrect or the page may have been removed.
        </p>

        <div className="flex flex-col sm:flex-row justify-center gap-4">
          <Button
            as={Link}
            className="py-2 px-6"
            color="primary"
            to="/dashboard"
          >
            Go to Dashboard
          </Button>
          <Button
            as="a"
            className="py-2 px-6"
            href="#"
            variant="light"
            onPress={() => window.history.back()}
          >
            Go Back
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
